module.exports = __webpack_public_path__ + "static/img/pic-1.ef159ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic-1.png
// module id = iFg+
// module chunks = 0